import { FlexGrid } from '@honeycomb/ui-core';
import React from 'react';
import { Weather } from '../../content/Weather/Weather';
import { FlightRoutes } from '../../content/FlightRoutes';
export function WeatherFlightRoute({ weatherData, routeData }) {
    return (React.createElement(FlexGrid, { container: true, spacing: 5.5 },
        routeData && (React.createElement(FlexGrid, { xs: 12, l: weatherData ? 6 : 12 },
            React.createElement(FlightRoutes, { routeData: routeData }))),
        weatherData && (React.createElement(FlexGrid, { xs: 12, l: routeData ? 6 : 12 },
            React.createElement(Weather, { weatherData: weatherData })))));
}
